import axios from 'axios';

const instance = axios.create({
  baseURL: '/.netlify/functions/chat',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
